import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
  name: 'momentDateCalendar',
  standalone: false,
})
export class MomentDateCalendarPipe implements PipeTransform {
  transform(value: number, timezone: string): string | null {
    return moment.unix(value / 1000)
      .calendar();
  }
}
